var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UpdateContainerWithSOB.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2f6d4f7a\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UpdateContainerWithSOB.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/Pendency/UpdateContainerWithSOB.vue
// module id = 159
// module chunks = 0